import { css } from "@vitality-ds/system";
export default css({
  position: "absolute",
  $$spacing: "$space$md",
  right: "$$spacing",
  top: "$$spacing"
});